import React, { useContext, useEffect, useState } from "react";
import axios from "../../../../../axios/index";

// context
import { UserContext } from "../../../../Context/UserContextProvider";

// components
import { Form } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { removeCommas } from "@persian-tools/persian-tools";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles
import styles from "./ConsultantReportsServiceDetails.module.css";

// Images
import editIconBlue from "./../../../../../assets/img/DashboardICons/editIconBlue.svg";
import deleteIconRed from "./../../../../../assets/img/DashboardICons/TrashIcon.svg";

const ConsultantReportsServiceForm = ({ formValue, setFormValue, showWhich, setShowWhich, setIsLoading, id, estateId }) => {
  const { userToken, permissions } = useContext(UserContext);
  let [time, setTime] = useState(new Date());
  const history = useHistory();

  console.log(id);

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  const formChangeHandler = e => {
    if (e.target.name === "price") {
      setFormValue({
        ...formValue,
        [e.target.name]: removeCommas(e.target.value),
      });
    } else {
      setFormValue({
        ...formValue,
        [e.target.name]: e.target.value,
      });
    }
  };

  const selectDateChangeHandler = value => {
    setFormValue(prev => {
      return { ...prev, date: value, dateChanged: true };
    });
  };

  const selectTimeChangeHandler = value => {
    setTime(value);
  };

  function getTime() {
    if (time instanceof Date) {
      return `${time.getHours()}:${time.getMinutes()}`;
    } else {
      return `${time.hour}:${time.minute}`;
    }
  }

  useEffect(() => {
    let time = new Date();
    let splitTime = formValue.time.split(":");

    time.setHours(parseInt(splitTime[0]));
    time.setMinutes(parseInt(splitTime[1]));
    setTime(time);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }
                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    .rmdp-wrapper {
                        width: 100% !important;
                        box-shadow: none !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                    }
                    .rmdp-wrapper input {
                        font-size: 24px !important;
                        width: 45px !important;
                        color: #363636 !important;
                    }
                    .dvdr{
                        font-size: 35px !important;
                        color: #D9D9D9 !important;
                    }
                    `}
      </style>

      <div dir="rtl" className={`text-right mx-4 px-2 mt-1 mb-3 d-inline-block`}>
        <div className={`d-flex justify-content-between align-items-start flex-wrap my-3 py-3`}>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="ownerName">
              نام مالک
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="ownerName"
              name="ownerName"
              value={formValue.ownerName}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="ownerPhone">
              شماره مالک
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="tel"
              id="ownerPhone"
              name="ownerPhone"
              value={formValue.ownerPhone}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="customerName">
              نام مشتری
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="customerName"
              name="customerName"
              value={formValue.customerName}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="customerPhone">
              شماره مشتری
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="tel"
              id="customerPhone"
              name="customerPhone"
              value={formValue.customerPhone}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="code">
              کد فایل
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="code"
              name="code"
              value={formValue.code}
              onChange={formChangeHandler}
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column position-relative`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="price">
              قیمت
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="price"
              name="price"
              value={addCommas(removeNonNumeric(formValue.price))}
              onChange={formChangeHandler}
            />
            <Form.Text className={`${styles.form_smallText_input} position-absolute top-50 start-0 px-3`}>تومان</Form.Text>
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="area">
              منطقه
            </Form.Label>
            <Form.Control
              className={`${styles.form_control_input} shadow-none`}
              type="text"
              id="area"
              name="area"
              value={formValue.area}
              onChange={formChangeHandler}
            />
          </Form.Group>

          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="selectDate">
              انتخاب تاریخ
            </Form.Label>
            <DatePicker
              id="date"
              name="date"
              value={formValue.date}
              onChange={selectDateChangeHandler}
              calendar={persian}
              locale={persian_fa}
              // format="DD MMMM YYYY"
            />
          </Form.Group>
          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="selectTime">
              انتخاب زمان
            </Form.Label>
            <DatePicker
              id="time"
              name="time"
              value={time}
              onChange={selectTimeChangeHandler}
              calendar={persian}
              locale={persian_fa}
              disableDayPicker
              format="HH:mm"
              plugins={[<TimePicker hideSeconds />]}
            />
          </Form.Group>

          <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="serviceResult">
              نتیجه گزارش
            </Form.Label>
            <Form.Control
              style={{ resize: "none" }}
              className={`${styles.form_control_input} shadow-none`}
              as="textarea"
              rows={9}
              id="serviceResult"
              name="serviceResult"
              value={formValue.serviceResult}
              onChange={formChangeHandler}
            />
          </Form.Group>
        </div>

        {permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 19) === 19 ? (
          <div className="d-flex justify-content-end align-items-center mb-4">
            <div
              className={`${styles.total_form_edit_btn} text-center d-flex justify-content-center align-items-center me-3`}
              role="button"
              onClick={editReport}>
              <img className={`ps-2 ms-1`} src={editIconBlue} alt="edit-form-icon" width={`25`} />
              <button style={{ color: "#21409a" }} className={`border-0 bg-transparent`}>
                ویرایش
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function deleteReportHandler() {
    try {
      notify("درحال حذف", "success");
      setIsLoading(true);
      const deleteHandler = await axios.delete(`ConsultantCardService?cardId=${id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(deleteHandler)
      setIsLoading(false);
      history.push({
        pathname: `/consultant-reports/${estateId}`,
        state: {
          detail: {
            id: estateId,
          },
        },
      });
      notify("با موفقیت حذف شد", "success");
    } catch (error) {
      notify("خطای سرور", "error");
    }
    // history.push(`/consultant-reports/${id}`)
  }

  async function editReport() {
    try {
      notify("درحال ویرایش", "success");
      // setIsLoading(true)
      var data = new FormData();
      data.append("Id", id);
      data.append("Ownername", formValue.ownerName);
      data.append("OwnerPhoneNumber", formValue.ownerPhone);
      data.append("CustomerName", formValue.customerName);
      data.append("CustomerPhoneNumber", formValue.customerPhone);
      // data.append('FileCode', 327801);
      data.append("FileCode", formValue.fileCode);
      data.append("Price", formValue.price);
      data.append("Area", formValue.area);
      data.append("ReportResult", formValue.serviceResult);
      if (formValue.dateChanged) {
        data.append("CardServiceDate", `${formValue.date.year}/${formValue.date.month.number}/${formValue.date.day}`);
      } else {
        data.append("CardServiceDate", formValue.date);
      }

      data.append("CardServiceTime", getTime());
      const editData = await axios.put("ConsultantCardService", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(editData)
      notify("با موفقیت ویرایش شد", "success");
      history.push({
        pathname: `/consultant-reports/${estateId}`,
        state: {
          detail: {
            id: estateId,
          },
        },
      });
      // setIsLoading(false)
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }
};

export default ConsultantReportsServiceForm;
